import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { WikiPanelService } from '../../services/wiki/wiki-panel.service';

@Component({
  selector: 'app-wiki-help-button',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './wiki-help-button.component.html',
  styleUrl: './wiki-help-button.component.scss',
})
export class WikiHelpButtonComponent {
  @Input({ required: true }) topicId!: string;
  @Input() label = 'Open help for this page';

  private readonly wikiPanelService = inject(WikiPanelService);

  openHelp(event: Event): void {
    event.stopPropagation();
    this.wikiPanelService.open(this.topicId);
  }
}
